export const useOnChangeValue = (setValue) => {
  return (val, item) => {
    switch (item.name) {
      case 'warrantyNumberCode':
        setValue('mobileBrandId', '');
        setValue('mobileModelId', '');
        setValue('mapProductId', '');
        break;
      case 'mobileBrandId':
        setValue('mobileModelId', '');
        setValue('mapProductId', '');
        break;
      case 'mobileModelId':
        setValue('mapProductId', '');
        break;
      case 'channelBuyId':
        setValue('storeId', '');
        setValue('warrantyTypeId', '');
        break;
      default:
        break;
    }
  };
};
